import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";
import CircularProgress from "@/plugins/circular-progress/circular-progress.vue";

export default defineComponent ({
    name: "VisitDetails",
    inheritAttrs: false,
    components: {
        CircularProgress,
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        },
        visitDetails: {
            type: Object,
            required: true
        }
    },
    setup() {
        const portal = usePortalStore();
        
        return {
            portal
        };
    }
});